import React, { Component } from 'react'
import './Warehousing.css'
let warehouse='Details not available'
class Warehousing extends Component {
    constructor(props) {
        super(props)
    }
    componentWillReceiveProps(nextProps){
        warehouse=nextProps.transporter_data.warehousing_services;
        if(warehouse==undefined || warehouse==null){
            warehouse='Details not available'
    
        }
    }
    render() {
        if(warehouse.provideService=="yes" || warehouse.provideService=="Yes" || warehouse.provideService=="1" || warehouse.provideService==1){
        return (
            <>
            <div className="warehousingcard" style={{marginTop:'3%'}}>
            <div className="warehousingcontainer row">
                <div className="col-12">
                    <span className="data_header padding-text"><b>Warehousing Services</b></span>
                </div>
                <div className="col">
                <div className="warehousing"><span>{(warehouse.area)?(`${warehouse.area} sq.ft`):('')} </span></div>
                <div className="warehousing"><span>{(warehouse.hubs)?(`${warehouse.hubs} hubs`):('')} </span></div>
                </div>
            </div>
            </div>
            </>
        )
    }
    else{
        return (
            <>
            <div className="warehousingcard" style={{marginTop:'3%'}}>
            <div className="warehousingcontainer row">
            <div className="col-12">
                <span className="data_header padding-text"><b>Warehousing Services</b></span>
                </div>
                <div className="col">
                <div className="warehousing padding-text"><span>Details not available</span></div>
                </div>
            </div>
            </div>
            </>)  
    }
    }
}

export default Warehousing
